whenAvailable('$', function() {
$(function(){
    // 'type', 'x', 'y', 'new', 'description', 'anchor', 'position of popover', 'next popover class'
    var pointers = {
        'headpillow' : ['headpillow', '34.5%', '-1%', 'new', localization['popover_description_10'], 'head_pillow', 'left', 'material'],
        'material' : ['material', '48.5%', '14%', 'new', localization['popover_description_1'], 'materials', 'right', 'backrest'],
        'backrest' : ['backrest', '29%', '20%', 'new', localization['popover_description_2'], 'seatbase', 'right', 'recline'],
        'recline' : ['recline', '13.5%', '25.5%', 'new', localization['popover_description_4'], 'lumbar', 'right', 'lumbar'],
        'lumbar' : ['lumbar', '44.5%', '23.5%', 'new', localization['popover_description_3'], 'lumbar', 'right', 'armrests'],
        'armrests' : ['armrests', '85%', '27%', 'new', localization['popover_description_11'], 'armrests', 'left', 'sidecovers'],
        'sidecovers' : ['sidecovers', '4%', '33%', 'new', localization['popover_description_6'], '', 'right', 'seatbase'],
        'seatbase' : ['seatbase', '60%', '41%', 'new', localization['popover_description_5'], 'seatbase', 'right', 'levers'],
        'levers' : ['levers', '78.5%', '51.5%', 'new', localization['popover_description_7'], '', 'right', 'wheelbase'],
        'wheelbase' : ['wheelbase', '63%', '75%', '', localization['popover_description_8'], 'testing', 'right', 'casters'],
        'casters' : ['casters', '40.5%', '92.5%', '', localization['popover_description_9'], '', 'right', 'headpillow']
    }

    var svg_template = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 70.67 70.67" class="chair-pointer pointer-{0}" data-type="{0}" style="left: {1}; top: {2};" data-bs-toggle="popover" data-bs-html="true" data-placement="{6}" data-bs-content='<div class="row align-items-center"><a class="popover-close text-secondary d-lg-none">Close</a><div class="col">{3}<p>{4}</p>{5}</div><div class="col-auto d-lg-none pointer popover-next" id="pointer-{7}"><img src="https://images.secretlab.co/theme/common/icon-v-arrow-right.png" alt=""></div></div>'>
        <circle class="cls-1" cx="35.33" cy="35.33" r="35.33"/>
        <path class="cls-2" d="M55.83,34.33H36.33V14.83a1,1,0,1,0-2,0v19.5H14.83a1,1,0,1,0,0,2h19.5v19.5a1,1,0,0,0,2,0V36.33h19.5a1,1,0,0,0,0-2Z"/>
    </svg>`;

    function format(source, params) {
        $.each(params,function (i, n) {
            source = source.replace(new RegExp("\\{" + i + "\\}", "g"), n);
        })
        return source;
    }

    // popover function to close, anchor and next
    function hide_popover() {
        $('#chair_pointers').removeClass('interacted');
        $('#chair_outline g path').removeClass('highlighted');
        $('[data-bs-toggle="popover"]').removeClass('active');
        $('.popover').popover('hide');
    }

    $.each( pointers, function( key, array ) {
        if (array[3] == 'new') {
            array[3] = array[3].replace('new', '<span class="badge bg-dark badge-polygon text-uppercase mb-2">'+ localization['new_and_improved'] +'</span>');
        }

        if (array[5] != '') {
            if (key == 'material' || key == 'wheelbase') {
                array[5] = array[5].replace(array[5], '<a href="#'+ array[5] +'" class="btn btn-link text-uppercase fw-bold p-0">'+ localization['see_how_we_test'] +' <img src="https://images.secretlab.co/theme/common/icon-red-arrow-right.png" alt="Arrow Icon"></a>');
            } else {
                array[5] = array[5].replace(array[5], '<a href="#'+ array[5] +'" class="btn btn-link text-uppercase fw-bold p-0">'+ localization['learn_more'] +' <img src="https://images.secretlab.co/theme/common/icon-red-arrow-right.png" alt="Arrow Icon"></a>');
            }
        }

        var string = format(svg_template, array);
        $(string).appendTo('#chair_pointers');
    });

    whenAvailable('bootstrap', () => {
        // dismiss popover when click on others

        new Promise(resolve => {
            let count = 1;

            const check_timer_id = setInterval(() => {
                if($.fn?.popover || count === 10) {
                    clearInterval(check_timer_id);
                    resolve();
                }

                count++;
            }, 1000);
        }).then(() => {
            if(!$.fn?.popover) {
                return;
            }

            $('[data-bs-toggle="popover"]').popover({
                template: '<div class="popover technology-popover" role="tooltip"><div class="popover-arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>'
            });
        });

        $(document).on('click', '.popover-close', function(e){
            e.preventDefault();
            hide_popover();
        }).on('click', '.technology-popover .btn-link', function(e){
            e.preventDefault();
            hide_popover();

            $('html, body').animate({scrollTop: $(this.hash).offset().top - $('#nav_features').height()}, 1000);
        }).on('click', '.technology-popover .popover-next', function(e){
            var next_popover = $(this).attr('id');

            hide_popover();
            $('.' + next_popover).click();
            bootstrap.Popover.getInstance(document.querySelector('.' + next_popover)).show();
        });

        if ($(window).width() < 992 && isMobile) {
            $(window).on('scroll', function() {
                hide_popover();
            });
        }

        // click function to trigger chair outline and active effect on svg circle
        $('#chair_pointers .chair-pointer').each(function() {
            var type = $(this).data('type'),
                $outline_selector = $('#chair_outline g.path-' + type + ' path');

            $(this).on({
                mouseenter: function () {
                    if (!$("#chair_pointers .chair-pointer.active").length) {
                        $('#chair_pointers').addClass('interacted');
                        $outline_selector.addClass('highlighted');
                    }
                },
                mouseleave: function () {
                    if (!$("#chair_pointers .chair-pointer.active").length) {
                        $('#chair_pointers').removeClass('interacted');
                        $outline_selector.removeClass('highlighted');
                    }
                },
                click: function () {
                    if ($(this).hasClass('active')) {
                        $('#chair_pointers').removeClass('interacted');
                        $outline_selector.removeClass('highlighted');
                        $(this).removeClass('active');
                    } else {
                        $('#chair_pointers').addClass('interacted');
                        $outline_selector.addClass('highlighted');
                        $(this).addClass('active');
                    }
                }
            });
        });
    });

    // dismiss popover when click on others
    $('body').on('click', function (e) {
        $('[data-bs-toggle="popover"]').each(function () {
            if (!$(this).is(e.target) && $(this).has(e.target).length === 0 && $('.popover').has(e.target).length === 0) {
                var type = $(this).data('type');
                $('#chair_outline g.path-' + type + ' path').removeClass('highlighted');
                $(this).removeClass('active');
                $(this).popover && $(this).popover('hide');

                if (!$("#chair_pointers .chair-pointer.active").length) {
                    $('#chair_pointers').removeClass('interacted');
                }
            }
        });
    });

    // Add slideDown animation to Bootstrap dropdown when expanding.
    $('#nav_features .dropdown').on('show.bs.dropdown', function() {
        $(this).find('.dropdown-menu').first().stop(true, true).slideDown();
    });

    // Add slideUp animation to Bootstrap dropdown when collapsing.
    $('#nav_features .dropdown').on('hide.bs.dropdown', function() {
        $(this).find('.dropdown-menu').first().stop(true, true).slideUp();
    });

    whenAvailable('slick',function() {
        $('.slick-revolving').on('init', function(event, slick){
             whenAvailable('lazyload', function(){
                  setTimeout(function() {
                       initLazyload();
                  }, 500);
             });
        });
        function initSlickRevolving() {
             let slick_intialized = $('.slick-revolving').hasClass('slick-initialized');
             if ( !slick_intialized) {
                  $('.slick-revolving')?.slick({
                       mobileFirst: true,
                       infinite: false,
                       slidesToShow: 1.1,
                       slidesToScroll: 1,
                       centerMode: false,
                       centerPadding: '4vw',
                       dots: true,
                       prevArrow: '<div class="arrow-prev d-md-flex"><svg class="d-none d-md-block ms-auto me-3 me-xl-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60.5 115.95"><path d="M59.74 115.2a2.59 2.59 0 0 1-3.66 0L.76 59.8a2.58 2.58 0 0 1 0-3.65L56.08.76a2.58 2.58 0 0 1 3.66 3.65L6.24 58l53.5 53.56a2.59 2.59 0 0 1 0 3.66z"></path></svg></div>',
                       nextArrow: '<div class="arrow-next d-md-flex"><svg class="d-none d-md-block ms-3 ms-xl-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60.5 115.95"><path d="M.76.76a2.58 2.58 0 0 1 3.65 0l55.33 55.4a2.58 2.58 0 0 1 0 3.65L4.4 115.2a2.58 2.58 0 1 1-3.65-3.65L54.26 58 .76 4.42a2.59 2.59 0 0 1 0-3.66z"></path></svg></div>',
                       responsive: [
                            {
                                 breakpoint: 767,
                                 settings: {
                                      centerMode: true,
                                      centerPadding: 'calc(100vw / 8)'
                                 }
                            },
                            {
                            breakpoint: 1500,
                            settings: {
                                      centerMode: true,
                                      centerPadding: 'calc(100vw / 7)'
                                 }
                            }
                       ]
                  });

             }
        }
        initSlickRevolving();
        window.onresize = () => { initSlickRevolving() }
   });
});
});
